import React from "react";

import { ProtectedRoute, RouteItem } from "../../../core/routing/ProtectedRoute";
import { HomePage } from "./HomePage";

const assetsBasePath = "";

export const alternativeHomeRoute: RouteItem = {
    path: `${assetsBasePath}/`,
    component: HomePage,
    accessRights: [],
    name: "Home"
};

export const HomeRoutes: React.FunctionComponent = () => {
    return (
        <div>
            <ProtectedRoute protectedRouteData={alternativeHomeRoute} />
        </div>
    );
};
